import React, { useState } from 'react';
import SignIn from '../components/SignIn';
import ScrollToTop from '../components/ScrollToTop';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import { Account } from '../components/Accounts';
import Sidebar from '../components/Sidebar';

function SigninPage() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Account>
      <ScrollToTop />
      <Sidebar isOpen={isOpen} toggle={toggle} isHeader={true} />
      <Navbar toggle={toggle} isHeader={true} />
      <SignIn />
      <Footer />
    </Account>
  );
}

export default SigninPage;
